import { Action } from "redux"
import { ObjectFilter, QueryObjectsOptions } from "../util/objects"
import { EventObject } from "../util/events"

export const EVENT_REQUEST = 'EVENT_REQUEST'
export const EVENT_REQUEST_SUCCESS = 'EVENT_REQUEST_SUCCESS'
export const EVENT_REQUEST_FAILURE = 'EVENT_REQUEST_FAILURE'

export const EVENT_POLLING_START = 'EVENT_POLLING_START'
export const EVENT_POLLING_STOP = 'EVENT_POLLING_STOP'
export const EVENT_POLLING_TICK = 'EVENT_POLLING_TICK'
export const EVENT_MARK_VIEWED = 'EVENT_MARK_VIEWED'

export interface FetchEventsOptions extends QueryObjectsOptions {
  types?: string[]
  reset?: boolean
}

export interface fetchEventsAction extends Action {
  options?: FetchEventsOptions
  filter?: ObjectFilter
}

export interface FetchEventsSuccessAction extends Action {
  total: number,
  events: EventObject[]
  reset?: boolean
}

export interface StartEventPollingAction extends Action {
}

export interface StopEventPollingAction extends Action {
}

export interface EventPollingTickAction extends Action {
  latestEventCreatedAt: Date
}

export interface UpdateLastViewedAction extends Action { }

export function fetchEvents(filter?: ObjectFilter, options?: FetchEventsOptions): fetchEventsAction {
  return {
    type: EVENT_REQUEST,
    options,
    filter
  }
};

export function startEventPolling(): StartEventPollingAction {
  return {
    type: EVENT_POLLING_START
  }
};

export function stopEventPolling(): StopEventPollingAction {
  return {
    type: EVENT_POLLING_STOP
  }
};

export function markViewed(): UpdateLastViewedAction {
  return {
    type: EVENT_MARK_VIEWED
  }
};
